module.exports = require('./lib/schema-inspector');



/*****************
 ** WEBPACK FOOTER
 ** ./~/schema-inspector/index.js
 ** module id = 157
 ** module chunks = 0
 **/